<template>
  <l-cache ref="cache" :get-data="getItem" :id="$route.query.id">
    <ParkDetails slot-scope="{data}" :form-data="data"></ParkDetails>
  </l-cache>
</template>
<script>
import ParkDetails from './parkDetails'
export default {
  name: 'parkDetailsBox',
  components: {ParkDetails},
  methods: {
    async getItem (key) {
      let {items} = await this.$store.dispatch('park/getParkList', {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: this.$route.query.id}})
      return items[0]
    }
  }
}
</script>
